import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { routePaths } from 'router';
import { useGetManyWarehouseTasks } from 'api/warehouse-task/use-get-many-warehouses-tasks';
import { useMoveToPath } from 'shared/hooks/use-move-to-path';
import { useWhTaskFiltersStore } from 'shared/stores/use-wh-task-filters';
import { SearchFilter } from 'components/common/search-filter';
import styles from './trips-search.module.scss';

export const WhTaskSearch = () => {
  const [searchString, setSearchString] = useState('');
  const { setSearch } = useWhTaskFiltersStore();
  const { moveToPath } = useMoveToPath();

  const { data: whTasks, isError } = useGetManyWarehouseTasks({
    limit: 10,
    isHints: true,
    search: searchString,
    isSkip: !searchString,
  });

  const [options, setOptions] = useState<{ label: React.ReactNode; value: number }[]>([]);

  useEffect(() => {
    if (whTasks && !isError) {
      const values = whTasks.data.map((whTask) => ({
        label: (
          <>
            <Typography.Text strong>{whTask.compositeId}</Typography.Text>
            <Typography.Text className={styles.hintSecondaryInfo}> {whTask.clientOrderNumber}</Typography.Text>
          </>
        ),
        value: whTask.id,
      }));
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [whTasks, isError]);

  const handleSelect = (value: string) => {
    moveToPath(routePaths.whTask, { whTaskId: value });
  };

  return (
    <SearchFilter
      options={options}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={handleSelect}
    />
  );
};
